import * as React from 'react';

import type { HeadProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';

import { ButtonLink } from 'stile-shared/src/components/2020/common/ButtonLink';
import { Link } from 'stile-shared/src/components/2020/common/Link';
import { Logo } from 'stile-shared/src/components/2020/common/Logo';
import { Lead, PageHeading, Text } from 'stile-shared/src/components/2020/common/Primitives';
import { Column } from 'stile-shared/src/components/2020/layout/Column';
import { Icon } from 'stile-shared/src/components/2020/layout/Icon';
import { Row } from 'stile-shared/src/components/2020/layout/Row';
import { FACEBOOK_URL, INSTAGRAM_URL, TWITTER_URL } from 'stile-shared/src/constants';

import { theme } from 'styles/theme';

import { SEO } from 'templates/2020/SEO';

export function Head(props: HeadProps) {
  return (
    <SEO
      title="Stile Sylla-bus"
      description="Preparing you for the new science syllabus with coffee, incursions and networking (drinks on us!)"
      slug={props.location.pathname}
    />
  );
}

export function StileXLaunchPage() {
  const social = [
    {
      text: 'Facebook',
      iconId: 'facebook',
      url: FACEBOOK_URL,
    },
    {
      text: 'Instagram',
      iconId: 'instagram',
      url: INSTAGRAM_URL,
    },
    {
      text: 'Twitter',
      iconId: 'twitter',
      url: TWITTER_URL,
    },
  ];

  return (
    <Wrapper>
      <Container>
        <div style={{ padding: '20px', width: '30%' }}>
          <Logo width="100%" />
        </div>

        <div style={{ textAlign: 'center' }}>
          <PageHeading color="white">The Sylla-bus is swinging by your school</PageHeading>
          <Lead color="white" size="s">
            Preparing you for the new science syllabus with coffee, incursions and networking
            (drinks on us!)
          </Lead>
          <StaticImage src="../../../stile-shared/assets/images/nsw/roadshow.png" alt="" />
        </div>

        <div style={{ width: '100%', marginTop: '1.5rem' }}>
          <Links padding={theme.space.s}>
            <StyledButtonLink url="/nsw/" openInNewTab>
              <Text as="span" size="s" color="stileXDark" bold>
                Roadshow schedule
              </Text>
            </StyledButtonLink>

            <StyledButtonLink url="https://forms.gle/nhMVmb76BUx6WRzB6" openInNewTab>
              <Text as="span" size="s" color="stileXDark" bold>
                Booking form
              </Text>
            </StyledButtonLink>

            <StyledButtonLink url="/resources/new-nsw-syllabus/" openInNewTab>
              <Text as="span" size="s" color="stileXDark" bold>
                NSW Syllabus Implementation Guide
              </Text>
            </StyledButtonLink>

            <StyledButtonLink url="mailto:nswroadshow@stileeducation.com" openInNewTab>
              <Text as="span" size="s" color="stileXDark" bold>
                Get in touch
              </Text>
            </StyledButtonLink>
          </Links>
        </div>

        <div style={{ textAlign: 'center' }}>
          <Row justify="flex-start" space={theme.space.s}>
            {social.map((item) => (
              <Text
                key={item.text}
                size="xl"
                as={Link}
                variant="hover"
                url={item.url}
                title={item.text}
              >
                <Icon iconId={item.iconId} ariaText={item.text} iconColor="green1" />
              </Text>
            ))}
          </Row>
        </div>
      </Container>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  justify-content: center;

  width: 100%;
  height: 100%;

  background-color: ${theme.colors.stileXDark};
  overflow: scroll;
`;

const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: ${theme.space.siteWidth};
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: ${theme.space.measure};
  flex: 1 0 100%;
`;

const Links = styled(Column)`
  width: 100%;
  padding-top: 0;
`;

const StyledButtonLink = styled(ButtonLink)`
  && {
    box-sizing: border-box;
    width: 100%;
    max-width: ${theme.space.measure};
    min-height: 56px;
    border-radius: 56px;
  }
`;

export default StileXLaunchPage;
